// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTablePagination_wrapper__Xp7Za","page-size-selector":"DataTablePagination_page-size-selector__Pt49P","buttons-wrapper":"DataTablePagination_buttons-wrapper__4kDoS"};